"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@netgum/utils");

var AccountGame = /*#__PURE__*/function () {
  function AccountGame(apiMethods, contract, device, state) {
    _classCallCheck(this, AccountGame);

    this.apiMethods = apiMethods;
    this.contract = contract;
    this.device = device;
    this.state = state; //
  }

  _createClass(AccountGame, [{
    key: "joinAccountGame",
    value: function joinAccountGame(accountGame) {
      var accountAddress = this.state.accountAddress;
      var id = accountGame.id,
          deposit = accountGame.deposit,
          _accountGame$creator = accountGame.creator,
          account = _accountGame$creator.account,
          payment = _accountGame$creator.payment;
      var address = this.contract.virtualPaymentManager.address;
      var message = utils_1.abiEncodePacked('address', 'address', 'address', 'address', 'bytes', 'uint256')(address, accountAddress, account.address, deposit.token ? deposit.token.address : utils_1.ZERO_ADDRESS, payment.hash, deposit.value);
      var signature = this.device.signPersonalMessage(message);
      return this.apiMethods.joinAccountGame(accountAddress, id, signature);
    }
  }, {
    key: "startAccountGame",
    value: function startAccountGame(accountGame) {
      var accountAddress = this.state.accountAddress;
      var id = accountGame.id,
          deposit = accountGame.deposit,
          _accountGame$opponent = accountGame.opponent,
          account = _accountGame$opponent.account,
          payment = _accountGame$opponent.payment;
      var address = this.contract.virtualPaymentManager.address;
      var message = utils_1.abiEncodePacked('address', 'address', 'address', 'address', 'bytes', 'uint256')(address, accountAddress, account.address, deposit.token ? deposit.token.address : utils_1.ZERO_ADDRESS, payment.hash, deposit.value);
      var signature = this.device.signPersonalMessage(message);
      return this.apiMethods.startAccountGame(accountAddress, id, signature);
    }
  }]);

  return AccountGame;
}();

exports.AccountGame = AccountGame;